<template>
  <GroupTable
    :longTableId="longTableId"
    :cols="cols"
    :formData="formData"
  />
</template>

<script>
import long_table_mixin from "@/components/statistics/stats/tabs/long_table_mixin";
import notification_mixin from "@/components/statistics/stats/tabs/notification_mixin";
import GroupTable from "@/components/statistics/general/GroupTable.vue";

import { getPercent } from "@/utils/general";

export default {
  components: {
    GroupTable,
  },

  mixins: [long_table_mixin, notification_mixin],

  data() {
    return {
      longTableId: "opens-table",
      cols: {
        date: {
          label: "Период",
        },
        delivered: {
          label: "Доставлено",
          className: "bold",
        },
        openedTotal: {
          label: "Открыто",
        },
        opened: {
          label: "Уникальных открыто",
        },
      },
    };
  },

  created() {
    if (this.isNotification)
      delete this.cols.delivered;
  },

  methods: {
    formData(arr, groupBy) {
      // нужные поля для новостной ленты
      if (this.$store.getters.getExportFile.steptype === 23) {
        return arr.map((i) => {
          const { date, opened, openedTotal } = i;

          return {
            date: groupBy.id === 1 ? mt.tsToLocalDateTime(date) : mt.tsToLocalDateTime(date).substring(0, 10),
            opened: `<b>${this.fNum.format(opened)}</b>`,
            openedTotal: `<b>${this.fNum.format(openedTotal)}</b>`,
          };
        });
      }
      return arr.map(i => {
        const { date, delivered, opened, openedTotal, sent } = i;

        return {
          date: groupBy.id === 1 ? mt.tsToLocalDateTime(date) : mt.tsToLocalDateTime(date).substring(0, 10),
          delivered: `<b>${this.fNum.format(delivered)}</b> (${getPercent(sent, delivered)}%)`,
          opened: `<b>${this.fNum.format(opened)}</b> (${getPercent(delivered, opened)}%)`,
          openedTotal: `<b>${this.fNum.format(openedTotal)}</b> (${getPercent(delivered, openedTotal)}%)`,
        };
      });
    },
  },
};
</script>
